import {useTranslation} from "react-i18next";
import {createToggleHandler} from "../../common/Checkbox/helpers";
import {updateMode} from "../../../utilities/constants";
import {createNestedUpdateState} from "../../../utilities/componentFunctions";
import {chunkArray, getValues, isNotEmptyNorFalsy} from "../../../utilities/helperFunctions";
import {legalHoldEvenTriggerKeys} from "../../../i18next/keys";
import Checkbox from "../../common/Checkbox/Checkbox";
import PropertyFilterRow from "./PropertyFilterRow";
import React from "react";

function LegalHoldEventTriggersPanel(props) {
    const {t} = useTranslation(['legalHold', 'jobSchedule']);

    const {
        eventTrigger,
        updateState
    } = props;

    const toggleEnable = createToggleHandler({
        mode: updateMode.REDUX,
        updateState: createNestedUpdateState(updateState, ['eventTrigger', 'legalHoldEvents'])
    });

    const {
        legalHoldEvents,
        legalHoldName,
        legalHoldDescription,
        clientName,
        matterName
    } = eventTrigger;

    const chunkEvents = chunkArray(getValues(legalHoldEvenTriggerKeys), 3);
    const required = isNotEmptyNorFalsy(legalHoldEvents) ? '' : ' is-required';

    return (
        <>
            <div className="display-input">
                <label className="label is-heading">
                    {t('jobSchedule:label.legalHoldEvents')}
                </label>
                <label className="label is-note">
                    {t('jobSchedule:message.legalHoldEventsTriggerSchedule')}
                </label>

                <div className={'settings-table no-border tight-padding display-input' + required} style={{border: '1px solid transparent'}}>
                    <div className="table-row-group">
                        {chunkEvents.map((evnts, index) =>

                            <div key={index} className="settings-row">
                                {evnts.map(evnt =>

                                    <div key={evnt} className="table-cell no-stretch">
                                        <Checkbox name={evnt} label={t(`legalHold:trigger.${evnt}`)}
                                            checked={legalHoldEvents[evnt]} onClick={toggleEnable}
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="display-item">
                <label className="label is-heading">
                    {t('jobSchedule:label.propertyFilters')}
                </label>
                <label className="label is-note">
                    {t('jobSchedule:message.legalHoldEventsTriggerPropertyFilterUsage')}
                </label>

                <div className="settings-table align-middle tight-padding no-table-padding no-border" style={{marginTop: '0.5rem'}}>
                    <div className="table-header-group" style={{background: 'none'}}>
                        <div className="table-header">
                            <label className="label is-bold">
                                {t('jobSchedule:label.property')}
                            </label>
                        </div>
                        <div className="table-header">
                            <label className="label is-bold">
                                {t('jobSchedule:label.contains')}
                            </label>
                        </div>
                    </div>

                    <div className="table-row-group">
                        <PropertyFilterRow label={t('jobSchedule:filter.legalHoldName')} name={'legalHoldName'} property={legalHoldName} updateState={updateState}/>

                        <PropertyFilterRow label={t('jobSchedule:filter.legalHoldDescription')} name={'legalHoldDescription'} property={legalHoldDescription} updateState={updateState}/>

                        <PropertyFilterRow label={t('jobSchedule:filter.clientName')} name={'clientName'} property={clientName} updateState={updateState}/>

                        <PropertyFilterRow label={t('jobSchedule:filter.matterName')} name={'matterName'} property={matterName} updateState={updateState}/>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LegalHoldEventTriggersPanel;
